import {
  CREATE_NEW_PLAN_SUCCESS,
  CREATE_NEW_PLAN_FAILURE,
  CREATE_NEW_PLAN_REQUEST,
  LOAD_PLAN_SUCCESS,
  LOAD_PLAN_FAILURE,
  LOAD_PLAN_REQUEST,
  UPDATE_PLAN_REQUEST,
  UPDATE_PLAN_SUCCESS,
  UPDATE_PLAN_FAILURE,
  DELETE_PLAN_REQUEST,
  DELETE_PLAN_SUCCESS,
  DELETE_PLAN_FAILURE,
  CLEAR_PLAN,
  GET_PLANS_REQUEST,
  GET_PLANS_SUCCESS,
  GET_PLANS_FAILURE,
  EXPORT_PLAN_TO_EXCEL_REQUEST,
  EXPORT_PLAN_TO_EXCEL_SUCCESS,
  EXPORT_PLAN_TO_EXCEL_FAILURE,
} from '../constants'
import { clear } from "redux-localstorage-simple"

const defaultPlanState = {
  plans: [],
  templates: [],
  plan: {
    risks: [],
    name: 'Untitled'
  },
  pendingMessage: "",
  createSuccess: false,
  createPending: false,
  loadSuccess: false,
  loadPending: false,
  getPlansSuccess: false,
  getPlansPending: false,
  isTemplate: false,
  updateSuccess: false,
  updatePending: false,
  deleteSuccess: false,
  deletePending: false,
  exportSuccess: false,
  exportPending: false,
  exportData: [],
}

export default (state = defaultPlanState, action) => {

  var newState = {...state}

  switch (action.type){
    case CREATE_NEW_PLAN_REQUEST:
      newState.createSuccess = false;
      newState.createPending = true;
      newState.pendingMessage = "Just one second. We're fetching the plan content for you"
      return newState;
    case CREATE_NEW_PLAN_SUCCESS:
      // newState.plan = action.body;
      // newState.plan.name = 'Untitled';
      newState.createPending = false;
      newState.createSuccess = true;
      return newState;
    case CREATE_NEW_PLAN_FAILURE:
      newState.createPending = false;
      newState.createSuccess = false;
      return newState;
    case UPDATE_PLAN_REQUEST:
      newState.updateSuccess = false;
      newState.updatePending = true;
      newState.pendingMessage = "Just one second. We're updating the plan content for you"
      return newState;
    case UPDATE_PLAN_SUCCESS:
      newState.plan = action.body;
      newState.updateSuccess = true;
      newState.updatePending = false;
      return newState;
    case UPDATE_PLAN_FAILURE:
      newState.updateSuccess = false;
      newState.updatePending = false;
      return newState;
    case DELETE_PLAN_REQUEST:
      newState.deleteSuccess = false;
      newState.deletePending = true;
      return newState;
    case DELETE_PLAN_SUCCESS:
      newState.isTemplate = action.isTemplate;
      newState.deleteSuccess = true;
      newState.deletePending = false;
      return newState;
    case DELETE_PLAN_FAILURE:
      newState.deleteSuccess = false;
      newState.deletePending = false;
      return newState;
    case GET_PLANS_REQUEST:
      newState.getPlansSuccess = false;
      newState.getPlansPending = true;
      return newState;
    case GET_PLANS_SUCCESS:
      newState.plans = action.body;
      newState.isTemplate = action.isTemplate;
      newState.getPlansSuccess = true;
      newState.getPlansPending = false;
      return newState;
    case GET_PLANS_FAILURE:
      newState.isTemplate = false;
      newState.getPlansSuccess = false;
      newState.getPlansPending = false;
      return newState;
    case LOAD_PLAN_REQUEST:
      newState.loadSuccess = false;
      newState.loadPending = true;
      newState.pendingMessage = "Just one second. We're fetching the plan content for you"
      return newState;
    case LOAD_PLAN_SUCCESS:
      newState.plan = action.body;
      newState.plan.name = action.body.name;
      newState.loadPending = false;
      newState.loadSuccess = true;
      return newState;
    case LOAD_PLAN_FAILURE:
      newState.loadPending = false;
      newState.loadSuccess = false;
      return newState;
    case EXPORT_PLAN_TO_EXCEL_REQUEST:
      newState.exportSuccess = false;
      newState.exportPending = true;
      return newState;
    case EXPORT_PLAN_TO_EXCEL_SUCCESS:
      newState.exportData = action.body;
      newState.exportSuccess = true;
      newState.exportPending = false;
      return newState;
    case EXPORT_PLAN_TO_EXCEL_FAILURE:
      newState.exportSuccess = false;
      newState.exportPending = false;
      return newState;
    case CLEAR_PLAN:
      newState = defaultPlanState;
      clear(); //Clears the Redux LocalStorage
      return newState;
    default:  return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/plan.js